"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarButton = exports.IToolbarButtonType = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var MBIconButton_1 = require("../MBIconButton");
var themes_1 = require("../../themes");
var LIST_TYPES = ['numbered-list', 'bulleted-list'];
var IToolbarButtonType;
(function (IToolbarButtonType) {
    IToolbarButtonType["mark"] = "mark";
    IToolbarButtonType["block"] = "block";
})(IToolbarButtonType = exports.IToolbarButtonType || (exports.IToolbarButtonType = {}));
var toggleBlock = function (editor, format) {
    var isActive = isBlockActive(editor, format);
    var isList = LIST_TYPES.includes(format);
    slate_1.Transforms.unwrapNodes(editor, {
        match: function (n) {
            return LIST_TYPES.includes(!slate_1.Editor.isEditor(n) && slate_1.Element.isElement(n) && n.type);
        },
        split: true,
    });
    var newProperties = {
        type: isActive ? 'paragraph' : isList ? 'list-item' : format,
    };
    slate_1.Transforms.setNodes(editor, newProperties);
    if (!isActive && isList) {
        var block = { type: format, children: [] };
        slate_1.Transforms.wrapNodes(editor, block);
    }
};
var toggleMark = function (editor, format) {
    var isActive = isMarkActive(editor, format);
    if (isActive) {
        slate_1.Editor.removeMark(editor, format);
    }
    else {
        slate_1.Editor.addMark(editor, format, true);
    }
};
var isBlockActive = function (editor, format) {
    var _a = __read(slate_1.Editor.nodes(editor, {
        match: function (n) {
            return !slate_1.Editor.isEditor(n) && slate_1.Element.isElement(n) && n.type === format;
        },
    }), 1), match = _a[0];
    return !!match;
};
var isMarkActive = function (editor, format) {
    var marks = slate_1.Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
var ToolbarButton = function (_a) {
    var type = _a.type, format = _a.format, Icon = _a.Icon, tooltip = _a.tooltip;
    var editor = slate_react_1.useSlate();
    var isActive = type === IToolbarButtonType.block
        ? isBlockActive(editor, format)
        : isMarkActive(editor, format);
    return (jsx_runtime_1.jsx(MBIconButton_1.MBIconButton, { background: isActive ? themes_1.THEME.colors.secondary.VividSkyBlue25 : undefined, borderRadius: 4, tooltip: tooltip, onMouseDown: function (event) {
            event.preventDefault();
            if (type === IToolbarButtonType.block) {
                toggleBlock(editor, format);
            }
            else {
                toggleMark(editor, format);
            }
        }, padding: 0, Icon: {
            component: Icon,
            props: {
                size: 28,
                fill: isActive ? themes_1.THEME.colors.secondary.Blue100 : '#000',
            },
        } }, void 0));
};
exports.ToolbarButton = ToolbarButton;
//# sourceMappingURL=MBWysiwygToolbarButton.js.map